"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TwentyOneGameLogic = void 0;
const deal_processor_1 = require("./deal-processor");
const entities_manager_1 = require("./entities/entities-manager");
const twentyone_game_state_1 = require("./twentyone-game-state");
const event_queue_1 = require("../../common/event-queue");
const action_bus_1 = require("../../common/action-bus");
const twentyone_analytics_data_1 = require("./twentyone-analytics-data");
const commands_1 = require("./commands");
const auto_commands_1 = require("./commands/auto-commands");
class TwentyOneGameLogic {
    getAnalyicsData() {
        return Object.assign({}, this.analyticsData);
    }
    constructor(dealer, cardIndexMapping, board, logicVersion) {
        this.dealer = dealer;
        this.board = board;
        this.logicVersion = logicVersion;
        this.logicActionBus = new action_bus_1.ActionBus();
        this.logicEventQueue = new event_queue_1.EventQueue();
        this.commandList = [];
        this.runningTasks = [];
        this.processingCommand = false;
        this.analyticsData = (0, twentyone_analytics_data_1.makeEmptyAnalyticsData)();
        this.entitiesManager = new entities_manager_1.EntitiesManager(board, this.logicEventQueue, logicVersion);
        this.twentyOneState = new twentyone_game_state_1.TwentyOneGameState(this.logicEventQueue, this.analyticsData);
        this.dealProcessor = new deal_processor_1.DealProcessor(board, dealer, cardIndexMapping);
        this.logicEventQueue.subscribe((event) => {
            switch (event.type) {
                case "onGameCompleted":
                    this.logicActionBus.emit("onGameCompleted");
                    break;
                case "onScoreChanged":
                    this.logicActionBus.emit("onScoreChanged", {
                        value: event.payload.value,
                    });
                    break;
                case "onRoundStateChanged":
                    this.logicActionBus.emit("onRoundStateChanged", {
                        state: event.payload.state,
                    });
                    break;
                default:
                    break;
            }
        });
    }
    serializeCommandList() {
        return this.commandList.map((command) => command.serializeToString());
    }
    generateScoreData() {
        return this.twentyOneState.currentScoreData;
    }
    startGame(existingGame) {
        return __awaiter(this, void 0, void 0, function* () {
            this.twentyOneState.initGame(existingGame);
            this.logicEventQueue.enqueue({
                type: "onGameInit",
                instant: existingGame,
                payload: { board: this.board.clone() },
            });
            const autoDealCommand = new auto_commands_1.AutoDealCommand();
            yield autoDealCommand.executeCommand(commands_1.CommandListSerializer.getHash(this.commandList), existingGame, this.makeGameContext());
        });
    }
    resetGame() {
        this.twentyOneState.reset();
    }
    moveToColumn(columnId) {
        this.executeCommand(new commands_1.PlayerMoveCommand(columnId));
    }
    waitForAllTasksToBeCompleted() {
        return __awaiter(this, void 0, void 0, function* () {
            yield Promise.all(this.runningTasks);
            this.runningTasks.length = 0;
        });
    }
    executeCommand(command, existingDeal = false, instant = false) {
        const task = this.execute(command, existingDeal, instant);
        this.runningTasks.push(task);
    }
    execute(command, existingDeal, instant) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.processingCommand) {
                return;
            }
            try {
                if (!command.validateCommand(this.makeGameContext(), existingDeal)) {
                    return;
                }
                this.processingCommand = true;
                this.commandList.push(command);
                this.logicActionBus.emit("onMoveExecuted", {
                    moves: [command.serializeToString()],
                    existingDeal,
                });
                const commandHash = commands_1.CommandListSerializer.getHash(this.commandList);
                yield command.executeCommand(commandHash, instant, this.makeGameContext());
                this.processingCommand = false;
            }
            catch (error) {
                this.logicActionBus.emit("onFatalError", {
                    context: "Execute blackjack command",
                    error,
                });
            }
        });
    }
    makeGameContext() {
        return {
            entitiesManager: this.entitiesManager,
            gameState: this.twentyOneState,
            dealProcessor: this.dealProcessor,
            eventQueue: this.logicEventQueue,
            analyticsData: this.analyticsData,
            logicVersion: this.logicVersion,
        };
    }
}
exports.TwentyOneGameLogic = TwentyOneGameLogic;
